import styled, { css } from 'styled-components';

import { BaseStyle, BaseStyleEnums } from '@nhl/nhl-breakaway-ui';

const STANDARD_PADDING_OFFSET = '32px';

export const FlexCenter = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
`;

export const PlayerFeaturedStatsContainer = styled.div`
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding: 28px 0 16px 0;

    ${BaseStyle.Mixins.screenSizes.large} {
        padding-left: 26px;
    }
`;

export const StatsColumn = styled.div`
    ${BaseStyle.Mixins.screenSizes.large} {
        min-width: calc(100vw - 472px);
    }

    width: calc(100vw - ${STANDARD_PADDING_OFFSET});

    height: 210px;
    display: flex;
    flex-direction: column;
`;

export const ToggleContainer = styled.div`
    width: 136px;
    position: static;

    ${BaseStyle.Mixins.screenSizes.large} {
        position: absolute;
        top: 190px;
    }

    align-items: center;
    align-content: center;
    display: flex;
    flex-direction: row;

    .stats-chevron {
        font-size: 24px;
        opacity: 0.2;
        transition: 0.5s;

        &.clickable {
            opacity: 1;
            cursor: pointer;
        }

        path {
            color: ${({ theme }) =>
                theme.Team[window.__SITE_SETTINGS__.franchise.triCode.toUpperCase()]?.primary || theme.Utility.cta};
        }
    }
`;

export const StatsToggle = styled.div<{ $selected: boolean }>`
    transition: 0.5s;
    width: ${({ $selected }) => ($selected ? '96px' : '32px')};
    background: ${({ $selected, theme }) => {
        if ($selected) {
            return theme.Team[window.__SITE_SETTINGS__.franchise.triCode.toUpperCase()]?.primary || theme.Utility.cta;
        }

        return theme.Text.disabled;
    }};
    height: 4px;
    margin: 0 4px;
    cursor: pointer;
`;

export const StatsBarsContainer = styled.div<{ $toggled: boolean }>`
    display: flex;
    width: calc(200% + 84px);
    flex-direction: row;
    transition: transform 0.5s;
    transform: translate(0px, -28px);

    ${({ $toggled }) =>
        $toggled
            ? css`
                  transform: translate(-100vw, -28px) translate(${STANDARD_PADDING_OFFSET}, 0px); // when stats bars are flexed below player info div

                  ${BaseStyle.Mixins.screenSizes.large} {
                      transform: translate(-100vw, -28px) translate(382px, 0px); // this accounts for fixed width of player info div
                  }

                  ${BaseStyle.Mixins.screenSizes.extraLarge} {
                      transform: translate(-100vw, -28px)
                          translate(
                              min(382px + 100vw - ${BaseStyleEnums.ScreenWidthBreakpoints.extraLarge}px, 472px),
                              0px
                          ); // this is so stupid. it has something to do w the width of the child containers not getting bigger beyond a certain point that's just beyond the extra large breakpoint? idk
                  }
              `
            : 'transform: translate(0, -28px);'}
`;
